(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/vikinglotto/assets/javascripts/views/play-system-page.js') >= 0) return;  svs.modules.push('/modules/vikinglotto/assets/javascripts/views/play-system-page.js');

'use strict';

svs.vikinglotto.views.PlaySystemPage = Marionette.View.extend({
  viewOptions: ['showDrawCount', 'showPlayTogether'],
  showDrawCount: true,
  showPlayTogether: true,
  behaviors: [{
    behaviorClass: svs.numbergames.game_app.behaviors.LoadModuleComponent,
    module: 'vikinglotto',
    component: 'play'
  }, svs.numbergames.game.behaviors.AddWhittyBg],
  regions: {
    rowsContainerRegion: '#ngRowsContainerRegion',
    betslipRegion: '#ngBetslipRegion',
    payfooterRegion: '#ngPayfooterRegion'
  },
  template(data) {
    return svs.vikinglotto.templates.play_page(data);
  },
  initialize() {
    this.mergeOptions(this.options, this.viewOptions);
  },
  onRender() {
    if (svs.vikinglotto.components.play) {
      const model = this.model || new svs.numbergames.game_model.models.Wager({
        productId: svs.numbergames.productMapping.CONSTANTS.VIKINGLOTTO,
        boards: 1,
        jokerPrice: svs.numbergames.game.draw.isJokerOpen ? 10 : 0,
        isSystem: true
      }, {
        storageKey: 'system',
        parse: true,
        hasTickets: svs.vikinglotto.data.hasTickets
      });
      this.showChildView('rowsContainerRegion', new svs.vikinglotto.components.play.views.SystemRowContainer({
        model
      }));
      this.showChildView('betslipRegion', new svs.vikinglotto.components.play.views.Betslip({
        model,
        showDrawCount: this.showDrawCount,
        showPlayTogether: this.showPlayTogether
      }));
      this.showChildView('payfooterRegion', new svs.vikinglotto.components.play.views.Payfooter({
        model
      }));
    }
  }
});

 })(window);